import { Controller } from 'stimulus';

const SLIDE_TRANSITION_DURATION = 250;

class GrowthReviews extends Controller {
  connect() {
    this.isSliding = false;

    if (window.matchMedia('(max-width: 1199px').matches) {
      this.enableReviewByIndex(0);
    }
  }

  onToggle(event) {
    // Retrieve the review block that was clicked
    const reviewBlock = event.currentTarget.closest('[data-target="growth-reviews.review"]');

    // Retrieve the index of the review block that was clicked
    const index = parseInt(reviewBlock.getAttribute('data-index'), 10);

    // Check if the clicked review block is active, in that case we want to close all.
    const isClickedActive = reviewBlock.classList.contains('is-active');

    this.enableReviewByIndex(index, isClickedActive);
  }

  onToggleReview(event) {
    // Retrieve the index of the review block that was clicked
    const index = parseInt(event.currentTarget.getAttribute('data-index'), 10);

    // Check if the clicked review block is active, in that case we want to close all.
    const isClickedActive = event.currentTarget.classList.contains('is-active');

    this.enableReviewByIndex(index, isClickedActive);
  }

  enableReviewByIndex(index, shouldCloseAll = false) {
    if (this.isSliding) {
      return;
    }

    this.isSliding = true;

    const canCloseAll = window.matchMedia('(min-width: 1200px').matches;

    // Loop over every review
    this.reviewTargets.forEach((reviewTarget, reviewIndex) => {
      // Remove all possible active classes
      reviewTarget.classList.remove('is-active', 'is-prev-active');

      // If the clicked review block is active, we want to close all reviews, and thus not continue.
      if (shouldCloseAll && canCloseAll) {
        return;
      }

      // The current clicked review is the active one
      if (reviewIndex === index) {
        reviewTarget.classList.add('is-active');

      // All previous reviews in the list get the prev-active class
      } else if (reviewIndex < index) {
        reviewTarget.classList.add('is-prev-active');
      }
    });

    setTimeout(() => {
      this.isSliding = false;
    }, SLIDE_TRANSITION_DURATION);
  }
}

GrowthReviews.targets = [
  'review',
];

export default GrowthReviews;
